var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('b-container',{staticClass:"bv-example-row"},[_c('b-row',[_c('b-col',[_c('div',{staticClass:"text-block-117"},[_vm._v("© Ins Montsià 2023")])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }